<script setup lang="ts">
import RoleCheckWrapper from '@components/role-check-wrapper.vue';
import { useExpressPickComposable } from '@src/express-pick/express-pick-composable.ts';
import StickyWrapper from '@components/layout-wrapper/sticky-wrapper.vue';

defineProps<{
    sticky?: boolean,
}>();

const { expressPickUser, expressPickWarehouses, expressPickError } = useExpressPickComposable();
</script>

<template>
    <RoleCheckWrapper v-if="expressPickUser && expressPickWarehouses.length > 0" :allowed-roles="['ROLE_EXPRESS_PICK']">
        <StickyWrapper v-if="sticky">
            <div :class="[$style.express_lightning, expressPickError ? $style.error : $style.happy]"/>
        </StickyWrapper>
        <div v-else :class="[$style.express_lightning, expressPickError ? $style.error : $style.happy]"/>
    </RoleCheckWrapper>
</template>

<style lang="scss" module>
@use '@backgrounds' as *;

.express_lightning {
    width: 100%;
    height: 20px;

    &.happy {
        background: linear-gradient(0deg, rgba(217,35,237,0%) 20%, rgba(217,35,237,40%) 100%);
    }

    &.error {
        background: linear-gradient(0deg, rgba(252,197,0,0%) 20%, rgba(252,197,0,40%) 100%);
    }
}
</style>
